export enum LogbookActionEnum {
    TEST,
    TEST2,
    CHANGE_TAB,
    HIDDEN_MARK_USER,
    SEARCH_USERS,
    SELECT_USER_TO_ASSIGN,
    SAVE_USER_LIST_MAP,
    LOADINGS,
    ACTIVITY_SECTION,
    SAVE_USER_ACTIVITIES_MARK,
    CHECK_USER,
    EDIT_UUID,
    EDIT_ERROR,
    LOAD_STATE
}